import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import Form from '../../FormIO/presentation/FormWithValidations';
import { getFormIoFormId } from '../DataTranscriberForm/redux-objects/actions';

interface IGenericDataTranscriberReduxProps {
  getFormIoFormId: () => void;
  dataTranscriberFormIoFormId: string;
}

function GenericDataTranscriberForm({ getFormIoFormId, dataTranscriberFormIoFormId }: IGenericDataTranscriberReduxProps) {
  useEffect(() => {
    if (!dataTranscriberFormIoFormId) getFormIoFormId();
  });

  return dataTranscriberFormIoFormId && (
    <Form
      formId={dataTranscriberFormIoFormId}
    />
  )
}

const mapDispatchToProps = {
  getFormIoFormId,
};

const mapStateToProps = (reduxState: any) => {
  return {
    dataTranscriberFormIoFormId: reduxState.DataTranscriber.DataTranscriberFormIoFormId,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(GenericDataTranscriberForm);